import { render, staticRenderFns } from "./CtaNoPhotosInStay.vue?vue&type=template&id=35ad8188&scoped=true"
import script from "./CtaNoPhotosInStay.vue?vue&type=script&lang=js"
export * from "./CtaNoPhotosInStay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ad8188",
  null
  
)

export default component.exports